import { ScrollView, Text, View } from "react-native";
import LoadingSpinner from "ui/atoms/spinner/LoadingSpinner";
import { Button, ButtonIcon, ButtonText } from "ui/gluestack/button";
import { AddIcon } from "ui/gluestack/icon";
import { Portal } from "ui/modules/ThrelsPortal/Portal";
import { useGetStatusFlagsIndexQuery } from "app/services/api/statusFlagsApi";
import { ViewStatusFlagCard } from "../organisms/ViewStatusFlagCard";
import { StatusFlagModel } from "app/services/api/types/statusFlags/models/StatusFlagModel";
import { useState } from "react";
import { PermissionCheck } from "app/features/permission/atoms/PermissionCheck";
import { PermissionsEnums } from "app/services/api/types/authorisation/enums/PermissionsEnums";
import { CreateEditFlagModal } from "../modals/CreateEditFlagModal";
import { DeleteFlagModal } from "../modals/DeleteFlagModal";

export function FlagsDashboardTemplate() {
  const { data, isLoading } = useGetStatusFlagsIndexQuery();
  const [isModalVisible, setModalVisible] = useState(false);
  const [isDeleteModalVisible, setDeleteModalVisible] = useState(false);
  const [editFlag, setEditFlag] = useState<StatusFlagModel | undefined>();
  const [deleteFlag, setDeleteFlag] = useState<StatusFlagModel | undefined>(
    undefined,
  );
  if (isLoading) {
    return (
      <View className="flex-1 justify-center items-center my-10">
        <LoadingSpinner />
      </View>
    );
  }

  const toggleModal = () => {
    setEditFlag(undefined);
    setModalVisible((prevState) => !prevState);
  };

  const startEditFlag = (flag: StatusFlagModel) => {
    setEditFlag(flag);
    setModalVisible(true);
  };

  const startDeleteFlag = (flag: StatusFlagModel) => {
    setDeleteFlag(flag);
    setDeleteModalVisible(true);
  };

  const handleSuccess = () => {
    setModalVisible(false);
    setEditFlag(undefined);
  };

  const handleDeleteSuccess = () => {
    setDeleteModalVisible(false);
    setDeleteFlag(undefined);
  };

  return (
    <View className="flex-1">
      <CreateEditFlagModal
        isVisible={isModalVisible}
        onClose={() => setModalVisible(false)}
        onSuccess={handleSuccess}
        flag={editFlag}
      />
      <DeleteFlagModal
        isVisible={isDeleteModalVisible}
        onClose={() => {
          setDeleteModalVisible(false);
          setDeleteFlag(undefined);
        }}
        onSuccess={handleDeleteSuccess}
        flag={deleteFlag}
      />
      <Portal hostName="headerButton" identifier="statusFlagsList">
        <PermissionCheck
          permission={PermissionsEnums.CREATE_STATUS_FLAG}
          fallback={<></>}
        >
          <Button
            className="mb-3"
            action="primary"
            size="sm"
            onPress={toggleModal}
          >
            <ButtonText>Create new status flag</ButtonText>
            <ButtonIcon as={AddIcon} className="w-4 h-4 ml-2" />
          </Button>
        </PermissionCheck>
      </Portal>
      <ScrollView contentContainerClassName="px-dashboard flex-1 flex">
        {data?.length ? (
          <View className="bg-secondary-0 rounded-lg gap-4 grid md:grid-cols-2 p-5">
            {data.map((flag) => (
              <ViewStatusFlagCard
                key={flag.id}
                flag={flag}
                onEdit={startEditFlag}
                onDelete={startDeleteFlag}
              />
            ))}
          </View>
        ) : (
          <View className="flex-1 my-5">
            <Text className="text-typography-600">
              No status flags have been created yet.
            </Text>
          </View>
        )}
      </ScrollView>
    </View>
  );
}
